<template>
  <div class="recovery-cont">
    <div class="recovery-header">
      <input-wrapper-2
          label="Application"
          info="Select the application instance for which you want to modify the settings for."
          :label-background-light="'#D2E2DE'"
          :label-background-dark="'#162627'"
      >
        <v-select
            ref="selectInstanceInput"
            v-model="selectedInstance"
            :items="instancesOptions"
            item-text="name"
            item-value="appId"
            placeholder="Select Instance"
            dense
            filled
            style="max-width: 400px; margin: 0 0 -14px;"
            :rules="[rules.required]"
        ></v-select>
      </input-wrapper-2>
    </div>
    <div class="recovery-content">
      <div class="recovery-cards">
        <v-card class="recovery-card debug-card">
          <v-card-title class="recovery-card_title">
            Trade Recovery Settings
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                    size="1em"
                    color="blue"
                    class="input-info recovery-tooltip"
                >
                  fas fa-info-circle
                </v-icon>
              </template>
              <div>
                Viable Combinations
                <ul>
                  <li>filter, recoveryconflict, tickets</li>
                  <li>filter, recoveryconflict, logins, from, to</li>
                  <li>filter, recoveryconflict, logins, symbol, from, to</li>
                  <li>filter, recoveryconflict, group, from, to</li>
                  <li>filter, recoveryconflict, group, symbol, from, to</li>
                </ul>
              </div>
            </v-tooltip>
          </v-card-title>
          <input-wrapper
              label="Filter"
              info="Should the groupmask and user exclusions be applied"
              container-class="pt-8"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="py-1 px-1">
              <v-switch
                  v-model="tradeRecoverySettings.filter"
                  :label="tradeRecoverySettings.filter === true ? 'Yes':'No'"
                  hide-details
                  style="margin-top: 0"
              ></v-switch>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Recovery Conflict"
              info="The operator must choose one of the 2 values"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-select
                  v-model="tradeRecoverySettings.recoveryconflict"
                  :items="recoveryconflictOptions"
                  :item-text="tradeRecoverySettings.recoveryconflict.text"
                  :item-value="tradeRecoverySettings.recoveryconflict.value"
                  filled
                  dense
                  hide-details
                  style="display: contents"
              ></v-select>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Tickets"
              info="Array of tickets"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-text-field
                  filled
                  dense
                  hide-details
                  hide-spin-buttons
                  v-model="tradeRecoverySettings.tickets"
                  type="text"
                  style="display: contents"
              ></v-text-field>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Logins"
              info="Array of client logins"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-text-field
                  filled
                  dense
                  hide-details
                  hide-spin-buttons
                  v-model="tradeRecoverySettings.logins"
                  type="text"
                  style="display: contents"
              ></v-text-field>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Symbol"
              info="Symbol name if we are interested only for the trades of one symbol"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-text-field
                  filled
                  dense
                  hide-details
                  v-model.number="tradeRecoverySettings.symbol"
                  style="display: contents"
              ></v-text-field>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Group"
              info="Groupmask"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-text-field
                  filled
                  dense
                  hide-details
                  v-model.number="tradeRecoverySettings.group"
                  style="display: contents"
              ></v-text-field>
            </div>
          </input-wrapper>
          <input-wrapper
              label="From"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1">
              <flat-pickr
                  v-model="tradeRecoverySettings.from"
                  :config="dateTimePickerConfig"
                  ref="tradeRecoveryFrom"
                  placeholder="select date and time"
                  @on-open="openDatePickerHandler('tradeRecoveryFrom')"
                  @on-close="closeDatePickerHandler('tradeRecoveryFrom')"
              />
              <v-btn icon :ripple="false">
                <v-icon
                    :class="datePickerPanels.tradeRecoveryFrom ? 'date-picker-icon active':'date-picker-icon'"
                    size="20px"
                    dense
                    @click="datePickerPanels.tradeRecoveryFrom ? acceptDatePickerHandler('tradeRecoveryFrom') : openDatePickerPanel('tradeRecoveryFrom')"
                >
                  {{ datePickerPanels.tradeRecoveryFrom ? 'fas fa-check' : 'far fa-calendar' }}
                </v-icon>
              </v-btn>
              <v-icon
                  v-show="datePickerPanels.tradeRecoveryFrom"
                  class="date-picker-icon"
                  color="red"
                  size="20px"
                  dense
                  @click="clearDatePickerHandler('tradeRecoveryFrom')"
              >
                fas fa-times
              </v-icon>
            </div>
          </input-wrapper>
          <input-wrapper
              label="To"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1">
              <flat-pickr
                  v-model="tradeRecoverySettings.to"
                  :config="dateTimePickerConfig"
                  ref="tradeRecoveryTo"
                  placeholder="select date and time"
                  @on-open="openDatePickerHandler('tradeRecoveryTo')"
                  @on-close="closeDatePickerHandler('tradeRecoveryTo')"
              />
              <v-btn icon :ripple="false">
                <v-icon
                    :class="datePickerPanels.tradeRecoveryTo ? 'date-picker-icon active':'date-picker-icon'"
                    size="20px"
                    @click="datePickerPanels.tradeRecoveryTo ? acceptDatePickerHandler('tradeRecoveryTo') : openDatePickerPanel('tradeRecoveryTo')"
                >
                  {{ datePickerPanels.tradeRecoveryTo ? 'fas fa-check' : 'far fa-calendar' }}
                </v-icon>
              </v-btn>
              <v-icon
                  v-show="datePickerPanels.tradeRecoveryTo"
                  class="date-picker-icon"
                  color="red"
                  size="20px"
                  @click="clearDatePickerHandler('tradeRecoveryTo')"
              >
                fas fa-times
              </v-icon>
            </div>
          </input-wrapper>
          <v-card-actions class="recovery-actions">
            <v-btn plain @click="cancelTradeRecoverySettings">
              Cancel
            </v-btn>
            <v-btn
                color="primary"
                :loading="savingTrades"
                :disabled="!selectedInstance"
                @click="saveTradeRecoverySettings"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="recovery-card debug-card d-flex flex-column">
          <v-card-title class="recovery-card_title">
            Daily Report Recovery Settings
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                    size="1em"
                    color="blue"
                    class="input-info recovery-tooltip"
                >
                  fas fa-info-circle
                </v-icon>
              </template>
              <div>
                Viable Combinations
                <ul>
                  <li>filter, recoveryconflict, logins, from, to</li>
                  <li>filter, recoveryconflict, group, from, to</li>
                </ul>
              </div>
            </v-tooltip>
          </v-card-title>

          <input-wrapper
              label="Filter"
              info="Should the groupmask and user exclusions be applied"
              container-class="pt-8"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="py-1 px-1">
              <v-switch
                  v-model="dailyReportRecoverySettings.filter"
                  :label="dailyReportRecoverySettings.filter === true ? 'Yes':'No'"
                  hide-details
                  style="margin-top: 0"
              ></v-switch>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Recovery Conflict"
              info="The operator must choose one of the 2 values"
              container-class="pt-8"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-select
                  v-model="dailyReportRecoverySettings.recoveryconflict"
                  :items="recoveryconflictOptions"
                  :item-text="dailyReportRecoverySettings.recoveryconflict.text"
                  :item-value="dailyReportRecoverySettings.recoveryconflict.value"
                  filled
                  dense
                  hide-details
                  style="display: contents"
              ></v-select>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Logins"
              info="Array of client logins"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-text-field
                  filled
                  dense
                  hide-details
                  hide-spin-buttons
                  v-model="dailyReportRecoverySettings.logins"
                  type="text"
                  style="display: contents"
              ></v-text-field>
            </div>
          </input-wrapper>
          <input-wrapper
              label="Group"
              info="Groupmask"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1" style="display: contents">
              <v-text-field
                  filled
                  dense
                  hide-details
                  v-model.number="dailyReportRecoverySettings.group"
                  style="display: contents"
              ></v-text-field>
            </div>
          </input-wrapper>
          <input-wrapper
              label="From"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1">
              <flat-pickr
                  v-model="dailyReportRecoverySettings.from"
                  :config="dateTimePickerConfig"
                  ref="dailyReportFrom"
                  pickername="dailyReportFrom"
                  placeholder="select date and time"
                  @on-open="openDatePickerHandler('dailyReportFrom')"
                  @on-close="closeDatePickerHandler('dailyReportFrom')"
              />
              <v-btn icon :ripple="false">
                <v-icon
                    :class="datePickerPanels.dailyReportFrom ? 'date-picker-icon active':'date-picker-icon'"
                    size="20px"
                    @click="datePickerPanels.dailyReportFrom ? acceptDatePickerHandler('dailyReportFrom') : openDatePickerPanel('dailyReportFrom')"
                >
                  {{ datePickerPanels.dailyReportFrom ? 'fas fa-check' : 'far fa-calendar' }}
                </v-icon>
              </v-btn>
              <v-icon
                  v-show="datePickerPanels.dailyReportFrom"
                  class="date-picker-icon"
                  color="red"
                  size="20px"
                  dense
                  @click="clearDatePickerHandler('dailyReportFrom')"
              >
                fas fa-times
              </v-icon>
              <!--          <div class="flatpickr">-->
              <!--            <input type="text" placeholder="Select Date.." data-input> &lt;!&ndash; input is mandatory &ndash;&gt;-->

              <!--            <a class="input-button" title="toggle" data-toggle>-->
              <!--              <i class="icon-calendar"></i>-->
              <!--            </a>-->

              <!--            <a class="input-button" title="clear" data-clear>-->
              <!--              <i class="icon-close"></i>-->
              <!--            </a>-->
              <!--          </div>-->
            </div>
          </input-wrapper>
          <input-wrapper
              label="To"
              container-class="pt-2"
              :label-background="$vuetify.theme.dark ? 'rgb(30,30,30)' : '#FFFFFF'"
          >
            <div class="px-1">
              <flat-pickr
                  v-model="dailyReportRecoverySettings.to"
                  :config="dateTimePickerConfig"
                  ref="dailyReportTo"
                  @on-open="openDatePickerHandler('dailyReportTo')"
                  @on-close="closeDatePickerHandler('dailyReportTo')"
                  placeholder="select date and time"
              />
              <v-btn icon :ripple="false">
                <v-icon
                    :class="datePickerPanels.dailyReportTo ? 'date-picker-icon active':'date-picker-icon'"
                    size="20px"
                    @click="datePickerPanels.dailyReportTo ? acceptDatePickerHandler('dailyReportTo') : openDatePickerPanel('dailyReportTo')"
                >
                  {{ datePickerPanels.dailyReportTo ? 'fas fa-check' : 'far fa-calendar' }}
                </v-icon>
              </v-btn>
              <v-icon
                  v-show="datePickerPanels.dailyReportTo"
                  class="date-picker-icon"
                  color="red"
                  size="20px"
                  :ripple="false"
                  @click="clearDatePickerHandler('dailyReportTo')"
              >
                fas fa-times
              </v-icon>
            </div>
          </input-wrapper>
          <v-spacer/>
          <v-card-actions class="recovery-actions">
            <v-btn plain @click="cancelDailyRecoverySettings">
              Cancel
            </v-btn>
            <span @mouseenter="touchError">
            <v-btn
                color="primary"
                :loading="savingDaily"
                :disabled="!selectedInstance"
                @click="saveDailyRecoverySettings"
            >
              Save
            </v-btn>
            </span>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import InputWrapper from "@/components/UI/InputWrapper.vue";
import InputWrapper2 from "@/components/UI/InputWrapper2.vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import "flatpickr/dist/themes/dark.css";
import {ApplicationInstanceService} from "@/services/ApiService";

/**
 * @component Recovery
 * Recovery settings component for the corresponding debugger tab item content
 */
export default {
  name: 'Recovery',
  components: {InputWrapper, InputWrapper2, flatPickr},
  data: () => ({
    loading: true,
    savingDaily: false,
    savingTrades: false,
    instancesList: [],
    instancesOptions: [],
    selectedInstance: null,
    tradeRecoverySettings: {
      filter: true,
      recoveryconflict: '',
      tickets: '',
      logins: '',
      symbol: '',
      group: '',
      from: '',
      to: '',
    },
    dailyReportRecoverySettings: {
      filter: true,
      recoveryconflict: '',
      logins: '',
      group: '',
      from: '',
      to: '',
    },
    recoveryconflictOptions: [
      {value: 1, text: 'Do Nothing'},
      {value: 2, text: 'Update'},
    ],
    datePickerPanels: {
      tradeRecoveryFrom: false,
      tradeRecoveryTo: false,
      dailyReportFrom: false,
      dailyReportTo: false,
    },
    dateTimePickerConfig: {
      enableTime: true,
      dateFormat: "d/m/Y H:i",
      wrap: true,
      defaultHour: 0
    },
    showTradeDatePickerFrom: false,
    showTradeDatePickerTo: false,
    showDailyDatePickerFrom: false,
    showDailyDatePickerTo: false,
    rules: {
      required: (v) => !!v || "Required",
    },
  }),
  mounted() {
    this.getLiveInstances();
  },
  methods: {
    /**
     * Check if user has selected an application instance from the dropdown
     * menu and display the corresponding error message accordingly
     */
    touchError() {
      // this.$refs.selectInstanceInput.focus();
      this.$refs.selectInstanceInput.validate(true);
      // console.log(this.$refs.selectInstanceInput);
      // console.log(this.$refs.selectInstanceInput.hasError);
    },
    /**
     * Get the live/available instances to display at the
     * application select dropdown menu
     */
    async getLiveInstances() {
      this.loading = true;
      try {
        const liveInstancesResponse = await ApplicationInstanceService.query({
          params: {fetchAvailable: true},
        });
        this.instancesList = liveInstancesResponse.data.filter(
            (el) => ((el.appStatus === "INITIALIZED") && (el.serverStatus === "CONNECTED"))
        );
        this.instancesOptions = this.instancesList.map((instanceItem) => {
          return {
            appId: instanceItem.id,
            name: instanceItem.serverName,
          };
        });
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    /**
     * handle the opening of a date picker panel
     * as specified by the pickerRef argument and register
     * the event/state of the corresponding date picker panel
     *
     * @param pickerRef {String} - the date picker reference to capture the event for
     */
    openDatePickerHandler(pickerRef) {
      // console.log(`pickerRef: ${pickerRef}`);
      // console.log(this.$refs[pickerRef]);
      this.datePickerPanels[pickerRef] = true;
    },
    /**
     * handle the dismissal of a date picker panel
     * as specified by the pickerRef argument and register
     * the event/state of the corresponding date picker panel
     *
     * @param pickerRef {String} - the date picker reference to capture the event for
     */
    closeDatePickerHandler(pickerRef) {
      // console.log(`pickerRef: ${pickerRef}`);
      // console.log(this.$refs[pickerRef]);
      this.datePickerPanels[pickerRef] = false;
    },
    /**
     * close the date picker panel
     * as specified by the pickerRef argument and register
     * the event/state of the corresponding date picker panel
     *
     * @param pickerRef {String} - the date picker reference to capture the event for
     */
    acceptDatePickerHandler(pickerRef) {
      // console.log(this.$refs[pickerRef]);
      // this.$refs[pickerRef].fp.clear();
      this.$refs[pickerRef].fp.close();
      this.datePickerPanels[pickerRef] = false;
    },
    /**
     * clear the selected date amd close the date picker panel
     * as specified by the pickerRef argument and register
     * the event/state of the corresponding date picker panel
     *
     * @param pickerRef {String} - the date picker reference to capture the event for
     */
    clearDatePickerHandler(pickerRef) {
      // console.log(this.$refs[pickerRef]);
      this.$refs[pickerRef].fp.clear();
      this.$refs[pickerRef].fp.close();
      this.datePickerPanels[pickerRef] = false;
    },
    /**
     * format the selected From date for Daily Report to the required/valid date format
     *
     * @param datetime {String} - datetime in "dd/mm/yyyy hh:mm" format
     * @returns {string|null}
     */
    dateFormatter(datetime) {
      if (!datetime) return null;

      // Directly parse the string based on the "dd/mm/yyyy hh:mm" format
      const parts = datetime.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/);
      if (!parts) {
        console.error('Invalid date format');
        return '';
      }
      // Re-arrange the parts into an ISO 8601 format date string
      const day = parts[1];
      const month = parts[2];
      const year = parts[3];
      const hours = parts[4];
      const minutes = parts[5];

      // Construct and return the ISO 8601 format date string
      return `${year}-${month}-${day}T${hours}:${minutes}:00`;
    },
    /**
     * Save the trade recovery settings
     */
    async saveTradeRecoverySettings() {
      // console.log('SAVING trade recovery settings');
      const formattedTradeRecoveryFrom = this.dateFormatter(this.tradeRecoverySettings.from);
      const formattedTradeRecoveryTo = this.dateFormatter(this.tradeRecoverySettings.to);
      // console.log(`Trade recovery From: ${formattedTradeRecoveryFrom}`);
      // console.log(`Trade recovery To: ${formattedTradeRecoveryTo}`);
      let ticketsArray = [];
      if (this.tradeRecoverySettings.tickets && (this.tradeRecoverySettings.tickets.length > 0)) {
        let stringArray = this.tradeRecoverySettings.tickets.split(",");
        ticketsArray = stringArray.map(Number);
      }
      let loginArray = [];
      if (this.tradeRecoverySettings.logins && (this.tradeRecoverySettings.logins.length > 0)) {
        let stringArray = this.tradeRecoverySettings.logins.replace(/ /g, '').split(",");
        loginArray = stringArray.map(Number);
      }
      const tradeRecoveryData = {
        command: 'CMD_AN_RECOVER_DEALS',
        payload: JSON.stringify({
          filter: this.tradeRecoverySettings.filter,
          recoveryconflict: this.tradeRecoverySettings.recoveryconflict,
          tickets: ticketsArray,
          logins: loginArray,
          symbol: this.tradeRecoverySettings.symbol,
          group: this.tradeRecoverySettings.group,
          from: formattedTradeRecoveryFrom,
          to: formattedTradeRecoveryTo,
        })
      };
      console.log('tradeRecoveryData');
      console.log(tradeRecoveryData);
      this.savingTrades = true;
      try {
        await ApplicationInstanceService.setRecoverySettings(this.selectedInstance, tradeRecoveryData.command, tradeRecoveryData.payload);
      } catch (error) {
        console.error(error);
        this.$notifier.error(
            "Couldn't set Trade Recovery settings."
        );
      }
      this.savingTrades = false;
    },
    /**
     * Cancel any changes made or reset to defaults if none present
     */
    cancelTradeRecoverySettings() {
      // console.log('Cancel/revert trade recovery settings changes');
      this.tradeRecoverySettings = {
        filter: false,
        recoveryconflict: '',
        tickets: '',
        logins: '',
        symbol: '',
        group: '',
        from: '',
        to: '',
      };
    },
    /**
     * Save the daily report recovery settings
     */
    async saveDailyRecoverySettings() {
      // console.log('SAVING daily report recovery settings');
      const formattedDailyReportFrom = this.dateFormatter(this.dailyReportRecoverySettings.from);
      const formattedDailyReportTo = this.dateFormatter(this.dailyReportRecoverySettings.to);
      // console.log(`dailyReport From: ${formattedDailyReportFrom}`);
      // console.log(`dailyReport To: ${formattedDailyReportTo}`);
      let loginArray = [];
      if (this.dailyReportRecoverySettings.logins && (this.dailyReportRecoverySettings.logins.length > 0)) {
        let stringArray = this.dailyReportRecoverySettings.logins.replace(/ /g, '').split(",");
        loginArray = stringArray.map(Number);
      }

      const dailyReportRecoveryData = {
        command: 'CMD_AN_RECOVER_DAILY_PROFITS',
        payload: JSON.stringify({
          recoveryconflict: this.dailyReportRecoverySettings.recoveryconflict,
          logins: loginArray,
          group: this.dailyReportRecoverySettings.group,
          from: formattedDailyReportFrom,
          to: formattedDailyReportTo,
        }),
      }
      // console.log('dailyReportRecoveryData');
      // console.log(dailyReportRecoveryData);
      this.savingDaily = true;
      try {
        await ApplicationInstanceService.setRecoverySettings(this.selectedInstance, dailyReportRecoveryData.command, dailyReportRecoveryData.payload);
        this.$notifier.success('Daily Report Recovery settings saved.')
      } catch (error) {
        console.error(error);
        this.$notifier.error('Could not save Daily Report Recovery settings.')
      }
      this.savingDaily = false;
    },
    /**
     * Cancel any changes made or reset to defaults if none present
     */
    cancelDailyRecoverySettings() {
      // console.log('Cancel/revert daily report settings changes');
      this.dailyReportRecoverySettings = {
        recoveryconflict: '',
        logins: '',
        group: '',
        from: '',
        to: '',
      };
    },

    openDatePickerPanel(target) {
      // console.log(target);
      // console.log(this.$refs);
      // console.log(this.$refs[target]);

      this.$refs[target]?.fp?.open();
      // console.log(`this.$refs[target].fp.isOpen: ${this.$refs[target]?.fp.isOpen}`);
      this.datePickerPanels[target] = true;
      // target.preventDefault();
      // target.fp.isOpen ? target.fp.close() : target.fp.open();
    }
  }
}
</script>

<style lang="scss" scoped>
.recovery-cont {
  width: 100%;
  display: flex;
  flex-direction: column;
  //flex-wrap: wrap;
  height: calc(100vh - 128px) !important;
  overflow-y: auto !important;
}

.recovery-header {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 8px 16px;
  background-color: rgba(28, 110, 89, 0.2);
}

.recovery-content {
  flex-grow: 1;
  overflow-y: auto;
}

.recovery-cards {
  width: 100%;
  display: flex;
  flex-direction: row;
  //flex-wrap: wrap;
  //flex-grow: 1;
  gap: 16px;
  align-items: unset;
  justify-content: space-evenly;
  padding: 16px 32px;
}

.recovery-card {
  width: fit-content;
  //min-width: 720px;
  padding: 16px 32px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.4) !important;

  & > .recovery-card_title {
    color: #a693f3;
    border-top: 1px solid #a693f3;
    border-bottom: 1px solid #a693f3;
    border-radius: 0 !important;
    padding-top: 4px;
    padding-bottom: 4px;
    box-sizing: content-box;
  }

  & .date-picker-input {
    border: none !important;
  }
}

.recovery-actions {
  width: 100%;
  align-items: center;
  justify-content: end;
}

.date-picker-icon {
  //margin-left: 8px;
  cursor: pointer;
  //background-color: rgba(255, 255, 255, 0.1) !important;
  padding: 4px;
  box-sizing: border-box;
  //height: 42px;
  //width: 32px;
  //border-bottom: 1px solid;

  &.active {
    color: green;
  }
}

.main-dark {
  input.flatpickr-input {
    color: #ffffff !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-bottom: 1px solid #ffffff !important;
    padding: 8px 12px !important;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2) !important;
    }
  }
}

.main-light {
  input.flatpickr-input {
    color: #000000 !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-bottom: 1px solid #000000 !important;
    padding: 8px 12px !important;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2) !important;
    }
  }
}

.recovery-tooltip {
  margin-left: 4px;
  cursor: help;
}
</style>

<style lang="scss">
.input-body {
  .v-text-field__details {
    margin: 0 !important;
  }
}
</style>
